'use strict';exports.__esModule = true;var limitedNumberLength = function limitedNumberLength(value, previousValue, limit) {
  if (value && +value !== 0) {
    if (value.toString().match(new RegExp('^(\\d{0,' + limit + '})$'))) {
      return parseInt(value, 10).toString();
    }
    return previousValue;
  }
  return '';
};

var maxThreeDigit = exports.maxThreeDigit = function maxThreeDigit(value, previousValue) {return limitedNumberLength(value, previousValue, 5);};exports.default =

{
  maxThreeDigit: maxThreeDigit };


//////////////////
// WEBPACK FOOTER
// ./src/helpers/reduxFormNormalizers.js
// module id = 1262
// module chunks = 0